<template>
  <div>
    <div class="row">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h3>Bookings</h3>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-4">
        <label for="inputState">Site</label>
        <select class="form-control" v-model="siteFilter">
          <option :value="null">All</option>
          <option
            v-for="site in siteSelect"
            :value="site.id"
            v-bind:key="site.id"
          >
            {{ site.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-4">
        <label for="inputState">Status</label>
        <select class="form-control" v-model="statusFilter">
          <option :value="null">All</option>
          <option
            v-for="status in statusSelect"
            :value="status.description"
            v-bind:key="status.id"
          >
            {{ status.description }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 card">
        <div class="card-body row">
          <div class="col-2">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
              size="mini"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table
              class="table-striped"
              :data="tableData"
              border
              style="width: 100%"
            >
              <el-table-column
                v-for="column in tableColumns"
                align="center"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                class-name="td-actions"
                label="Actions"
              >
                <template slot-scope="props">
                  <p-button
                    type="info"
                    size="sm"
                    icon
                    @click="handleLink(props.$index, props.row)"
                  >
                    <i class="fa fa-link"></i>
                  </p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              @input="inputChanged($event)"
            >
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Input, InputNumber, Form, FormItem, Button, Radio } from "element-ui";
import users from "src/components/Dashboard/Views/Tables/users";
import HTTP from "src/util/http-common.js";
import US_STATES from "src/util/us_states.js";
import Modal from "src/components/UIComponents/Modal.vue";
import { parse } from "path";
import swal from "sweetalert2";

export default {
  us_states: US_STATES,
  components: {
    Modal,
    [InputNumber.name]: InputNumber,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [Radio.name]: Radio,
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0,
      },
      tableColumns: [
        {
          prop: "id",
          label: "Booking ID",
          minWidth: 110,
        },
        {
          prop: "site",
          label: "Site",
          minWidth: 150,
        },
        {
          prop: "station",
          label: "Station",
          minWidth: 100,
        },
        {
          prop: "connection_point",
          label: "Connection",
          minWidth: 110,
        },
        {
          prop: "start_time",
          label: "Start Time",
          minWidth: 200,
        },
        {
          prop: "estimated_end_time",
          label: "End Time",
          minWidth: 200,
        },
        {
          prop: "status_description",
          label: "Status",
          minWidth: 120,
        },
      ],
      tableData: [],
      siteSelect: [],
      siteFilter: null,
      statusSelect: [],
      statusFilter: null,
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },
  watch: {
    "pagination.perPage": function (newVal, oldVal) {
      console.log("per page changed from ", oldVal, "to ", newVal);
      this.pagination.currentPage = 1;
      this.setBookings();
    },
    addNewSite: function (newVal, oldVal) {
      if (newVal == false) {
        this.siteModel.state = null;
        this.siteModel.name = "";
        this.siteModel.address = "";
        this.siteModel.city = "";
        this.siteModel.latitude = null;
        this.siteModel.longitude = null;
        this.siteModel.site_type = "";
      } else {
        this.$validator.errors.clear();
      }
    },
    siteFilter: function (newVal, oldVal) {
      console.log("siteFilter new val, oldVal", newVal, oldVal);
      this.setBookings();
    },
    statusFilter: function (newVal, oldVal) {
      console.log("statusFilter new val, oldVal", newVal, oldVal);
      this.setBookings();
    },
  },
  created() {
    //   this.setSites()
    this.setBookings();
    this.setSites();
    this.setStatus();
  },
  methods: {
    handleLink(index, row) {
      this.$router.push({ path: `/bookings/${row.id}` });
    },
    inputChanged(pageNum) {
      console.log("page changed", pageNum);
      this.setBookings();
    },
    async fetchBookings() {
      let params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.perPage,
      };
      if (this.siteFilter != null) {
        params["site_id"] = this.siteFilter;
      }

      if (this.statusFilter != null) {
        params["status"] = this.statusFilter;
      }

      const response = await HTTP.get("api/v1/booking/list", {
        params: params,
      });
      const data = await response.data;
      return data;
    },

    formatUTCDate(date) {
      const utcDate = new Date(date * 1000).toUTCString();
      // Format the UTC date
      const formattedDate = new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      }).format(new Date(utcDate));

      return formattedDate;
    },
    setBookings() {
      this.tableData = [];
      let loader = this.$loading.show();
      this.fetchBookings()
        .then((data) => {
          const results = data.results;
          for (var i = 0; i < results.length; i++) {
            const booking_id = results[i].id;
            const status = results[i].status_description;
            const start_time = results[i].start_time;
            const start_time_iso = this.$moment
              .unix(start_time)
              .format("MMMM Do YYYY, h:mm:ss a");
            const payments = data.results[i].payments;

            let total_reserved_hours = 0;
            let total_reduce_hours = 0;
            for (var b = 0; b < payments.length; b++) {
              total_reserved_hours += payments[b].reserved_hours;
              const refunds = payments[b].refunds;
              for (var a = 0; a < refunds.length; a++) {
                if (refunds[a].is_reduced) {
                  total_reduce_hours += refunds[a].hours;
                }
              }
            }

            // const est_end_time = start_time + (total_reserved_hours * 60 * 60)
            const est_end_time_iso = this.$moment
              .unix(results[i].end_time)
              .format("MMMM Do YYYY, h:mm:ss a");
            this.tableData.push({
              id: booking_id,
              site: results[i].connection.station.site.name,
              station: results[i].connection.station.station_number,
              connection_point: results[i].connection.connection_point,
              start_time: this.formatUTCDate(start_time),
              estimated_end_time: this.formatUTCDate(results[i].end_time),
              total_hours: total_reserved_hours - total_reduce_hours,
              status_description: status,
            });
          }
          this.pagination.total = data.total;
          loader.hide();
        })
        .catch((err) => {
          console.log(err.response.data.error);
          const error = err.response.data.error;
          this.$notify({
            group: "general",
            title: "Error fetching booking list",
            text: error,
            type: "error",
          });
          loader.hide();
        });
    },
    async fetchSites() {
      const response = await HTTP.get("api/v1/site/list", {});
      const data = await response.data;
      return data;
    },
    setSites() {
      this.fetchSites()
        .then((data) => {
          this.siteSelect = data.results;
        })
        .catch((err) => {
          console.log(err);
          // alert(err);
        });
    },
    async fetchBookingStatus() {
      const response = await HTTP.get("api/v1/booking/status/list", {});
      const data = await response.data;
      return data;
    },
    setStatus() {
      this.fetchBookingStatus()
        .then((data) => {
          this.statusSelect = data;
        })
        .catch((err) => {
          const error = err.response.data.error;
          this.$notify({
            group: "general",
            title: "Error fetching booking status",
            text: error,
            type: "error",
          });
        });
    },
  },
  mounted() {
    var p = localStorage.getItem("permissions");
    var pr = JSON.parse(p);
    var permissions = pr.permissions;

    var canShowBooking = permissions.includes("booking.get");

    if (canShowBooking === false) {
      this.$router.push({ path: "/" });
    }
  },
};
</script>
<style scoped lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
</style>
